module.exports = __webpack_public_path__ + "img/tg.96c1f63a.svg";